import _default from '@/pages/home/assets/img/flag/defcountry.svg';

// notionalMap CDN 链接
const NATIONAL_MAP_CDN_URL =
  'https://ogdb-cdn.intlgame.cn/front/pc/intelligence/national-map/';

const flagMap = {
  _default,
  _algeria: `${NATIONAL_MAP_CDN_URL}/algeria.png`,
  _argentina: `${NATIONAL_MAP_CDN_URL}/argentina.png`,
  _australia: `${NATIONAL_MAP_CDN_URL}/australia.png`,
  _austria: `${NATIONAL_MAP_CDN_URL}/austria.png`,
  _bahrain: `${NATIONAL_MAP_CDN_URL}/bahrain.png`,
  _belgium: `${NATIONAL_MAP_CDN_URL}/belgium.png`,
  _bengal: `${NATIONAL_MAP_CDN_URL}/bengal.png`,
  _bolivia: `${NATIONAL_MAP_CDN_URL}/bolivia.png`,
  _brazil: `${NATIONAL_MAP_CDN_URL}/brazil.png`,
  _canada: `${NATIONAL_MAP_CDN_URL}/canada.png`,
  _chile: `${NATIONAL_MAP_CDN_URL}/chile.png`,
  _china: `${NATIONAL_MAP_CDN_URL}/china.png`,
  _colombia: `${NATIONAL_MAP_CDN_URL}/colombia.png`,
  '_czech republic': `${NATIONAL_MAP_CDN_URL}/czech_republic.png`,
  _denmark: `${NATIONAL_MAP_CDN_URL}/denmark.png`,
  _ecuador: `${NATIONAL_MAP_CDN_URL}/ecuador.png`,
  _egypt: `${NATIONAL_MAP_CDN_URL}/egypt.png`,
  '_el salvador': `${NATIONAL_MAP_CDN_URL}/el_salvador.png`,
  _india: `${NATIONAL_MAP_CDN_URL}/india.png`,
  _finland: `${NATIONAL_MAP_CDN_URL}/finland.png`,
  _france: `${NATIONAL_MAP_CDN_URL}/france.png`,
  _germany: `${NATIONAL_MAP_CDN_URL}/germany.png`,
  _greece: `${NATIONAL_MAP_CDN_URL}/greece.png`,
  '_hong kong': `${NATIONAL_MAP_CDN_URL}/hong_kong.png`,
  _hungary: `${NATIONAL_MAP_CDN_URL}/hungary.png`,
  _indonesia: `${NATIONAL_MAP_CDN_URL}/indonesia.png`,
  _iraq: `${NATIONAL_MAP_CDN_URL}/iraq.png`,
  _ireland: `${NATIONAL_MAP_CDN_URL}/ireland.png`,
  _israel: `${NATIONAL_MAP_CDN_URL}/israel.png`,
  _italy: `${NATIONAL_MAP_CDN_URL}/italy.png`,
  _japan: `${NATIONAL_MAP_CDN_URL}/japan.png`,
  _jordan: `${NATIONAL_MAP_CDN_URL}/jordan.png`,
  _kuwait: `${NATIONAL_MAP_CDN_URL}/kuwait.png`,
  _lebanon: `${NATIONAL_MAP_CDN_URL}/lebanon.png`,
  _libya: `${NATIONAL_MAP_CDN_URL}/libya.png`,
  _malaysia: `${NATIONAL_MAP_CDN_URL}/malaysia.png`,
  _mexico: `${NATIONAL_MAP_CDN_URL}/mexico.png`,
  _morocco: `${NATIONAL_MAP_CDN_URL}/morocco.png`,
  _netherlands: `${NATIONAL_MAP_CDN_URL}/netherlands.png`,
  '_new zealand': `${NATIONAL_MAP_CDN_URL}/new_zealand.png`,
  _nigeria: `${NATIONAL_MAP_CDN_URL}/nigeria.png`,
  _norway: `${NATIONAL_MAP_CDN_URL}/norway.png`,
  _oman: `${NATIONAL_MAP_CDN_URL}/oman.png`,
  _pakistan: `${NATIONAL_MAP_CDN_URL}/pakistan.png`,
  _paraguay: `${NATIONAL_MAP_CDN_URL}/paraguay.png`,
  _peru: `${NATIONAL_MAP_CDN_URL}/peru.png`,
  _philippines: `${NATIONAL_MAP_CDN_URL}/philippines.png`,
  _poland: `${NATIONAL_MAP_CDN_URL}/poland.png`,
  _portugal: `${NATIONAL_MAP_CDN_URL}/portugal.png`,
  _qatar: `${NATIONAL_MAP_CDN_URL}/qatar.png`,
  _russia: `${NATIONAL_MAP_CDN_URL}/russia.png`,
  '_saudi arabia': `${NATIONAL_MAP_CDN_URL}/saudi_arabia.png`,
  _singapore: `${NATIONAL_MAP_CDN_URL}/singapore.png`,
  '_south africa': `${NATIONAL_MAP_CDN_URL}/south_africa.png`,
  '_south korea': `${NATIONAL_MAP_CDN_URL}/south_korea.png`,
  _spain: `${NATIONAL_MAP_CDN_URL}/spain.png`,
  _sweden: `${NATIONAL_MAP_CDN_URL}/sweden.png`,
  _switzerland: `${NATIONAL_MAP_CDN_URL}/switzerland.png`,
  _syria: `${NATIONAL_MAP_CDN_URL}/syria.png`,
  _taiwan: `${NATIONAL_MAP_CDN_URL}/taiwan.png`,
  _thailand: `${NATIONAL_MAP_CDN_URL}/thailand.png`,
  _tunisia: `${NATIONAL_MAP_CDN_URL}/tunisia.png`,
  _turkey: `${NATIONAL_MAP_CDN_URL}/turkey.png`,
  '_united arab emirates': `${NATIONAL_MAP_CDN_URL}/united_arab_emirates.png`,
  '_united kingdom': `${NATIONAL_MAP_CDN_URL}/united_kingdom.png`,
  '_united states': `${NATIONAL_MAP_CDN_URL}/united_states.png`,
  _uruguay: `${NATIONAL_MAP_CDN_URL}/uruguay.png`,
  _vietnam: `${NATIONAL_MAP_CDN_URL}/vietnam.png`,
  _yemen: `${NATIONAL_MAP_CDN_URL}yemen.png`,
};

/**
 * code: 国家缩写
 * source：扩展字段外部自定义源，优先从外部取，外部没有，从内部取
 * gemeCode：扩展字段游戏code，有些游戏可能会把某些国家的国旗强制换掉，方便后续方法的扩展
 */
export const getNationalMap = (code: string, source?: object) => {
  const countryCode = code ? `_${code?.toLowerCase()?.trim()}` : '_default';
  if (!source) {
    source = flagMap;
  }
  return source[countryCode] || source._default;
};
